export class AgentsRequestData {
    type: string;
    id_rol: string;
    rol_alias: string;
}